import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { EquipmentInventory } from "../../../features/FloorManager/typings/svg.types";

export function useRemoteFetchFilteredEquipmentInventory(
  locationIds: number[],
  options?: { enabled?: boolean }
) {
  const enabled = (options?.enabled ?? true) && locationIds.length > 0;

  return useRemoteQuery<EquipmentInventory[]>({
    queryKey: ["equipment-inventory-filtered", "location", locationIds],
    url: "/equipment-inventory/filtered",
    params: { type: "location", ids: locationIds },
    enabled
  });
}
